import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import { idbStorage } from './idbStorage';
export var useOboardingStore = create()(devtools(persist(function (set) { return ({
    onboardingComplete: false,
    disableExportDialog: false,
    setOnboardingComplete: function (onboardingComplete) {
        return set(function (_) { return ({ onboardingComplete: onboardingComplete }); });
    },
    setDisableExportDialog: function (disableExportDialog) {
        return set(function (_) { return ({ disableExportDialog: disableExportDialog }); });
    },
}); }, {
    name: 'onboarding-complete',
    version: 1,
    storage: idbStorage,
    partialize: function (_a) {
        var onboardingComplete = _a.onboardingComplete, disableExportDialog = _a.disableExportDialog;
        return ({
            onboardingComplete: onboardingComplete,
            disableExportDialog: disableExportDialog,
        });
    },
})));
